import { CircleCheck } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const executionMethodOptions: ComboboxFilterOption<string>[] = [
  { label: 'Automated', value: 'automated' },
  { label: 'Manual', value: 'manual' },
]

const TasksExecutionMethodFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = executionMethodOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Execution Method', options: filteredOptions || [] }]}
        placeholder='Search execution methods to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={executionMethodOptions || []}
          noSelectionText='Execution Method'
          pluralIdentifier='execution methods'
        >
          <CircleCheck size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default TasksExecutionMethodFilter
